import './CheckboxList.7e6c245e12de9dcd6dd92ebf437bdc26.css';
export default {"header":"_header_nzq6u_1","list":"_list_nzq6u_1","row":"_row_nzq6u_1","checkbox":"_checkbox_nzq6u_1","fullWidth":"_fullWidth_nzq6u_1"};